import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Params, Router } from '@angular/router';
import { IAuthService, IStorageService } from '@insight/services';
import { AuthService } from './auth.service';

@Component({
  selector: 'app-auth',
  templateUrl: './auth.component.html',
  styleUrls: ['./auth.component.scss']
})
export class AuthComponent implements OnInit {

  isStateInvalid: boolean;

  constructor(
    private activatedRoute: ActivatedRoute,
    private storageService: IStorageService,
    private authService: IAuthService,
    private router: Router
  ) { }

  ngOnInit(): void {
    const state = this.activatedRoute.snapshot.queryParamMap.get('st');
    const authToken = this.activatedRoute.snapshot.queryParamMap.get('at');
    const returnUrl = this.storageService.get('ru');
    const savedState = this.storageService.get('st');
    // if (state !== savedState) {
    //   console.log('Invalid saved state');
    //   this.isStateInvalid = true;
    //   return;
    // }

    this.getUserToken(authToken)
      .then(({ userToken, refreshToken }) => this.saveTokens({ userToken, refreshToken }))
      .then((userToken) => this.getMenuToken(userToken))
      .then((menuToken) => this.saveMenuToken(menuToken))
      .then(() => this.router.navigateByUrl(returnUrl))
      .catch((err) => {
        console.log(err);
      })
  }

  getUserToken(authToken: string): Promise<{ userToken: string, refreshToken: string }> {
    return this.authService.getUserToken(authToken)
      .toPromise();
  }

  getMenuToken(userToken: string): Promise<string> {
    return this.authService.getMenuToken(userToken)
      .toPromise()
  }

  saveTokens({ userToken, refreshToken }): Promise<string> {
    this.storageService.clear();
    this.storageService.set('ut', userToken);
    this.storageService.set('rt', refreshToken);
    return Promise.resolve(userToken);
  }

  saveMenuToken(menuToken): Promise<void> {
    this.storageService.set('mt', menuToken);
    return Promise.resolve();
  }

}
